import React from "react";
import { Typography, Box } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const SearchLabel = ({ label, minWidth = "auto" }) => {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <FiberManualRecordIcon
        style={{ width: "10px", marginTop: "3px" }}
        fontSize="small"
        color="primary"
      />
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        fontSize={12}
        sx={{
          minWidth: minWidth,   // 전달되면 적용
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default SearchLabel;
